$("#generateHTML").on('click', function(e) {
    e.preventDefault();
    let data = getData();
    var formData = new FormData();

    formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
    formData.append('title', data['title']);
    formData.append('quantidade', data['quantidade']);
    formData.append('potencia', data['potencia']);
    formData.append('horas', data['horas']);
    formData.append('dias_mes', data['dias_mes']);
    formData.append('dias_autonomia', data['dias_autonomia']);

    formData.append('consumo_diario', $("#consumo-diario").text());
    formData.append('consumo_mensal', $("#consumo-mensal").text());

    formData.append('valorModulos', $("#valorPotModulos").text());
    formData.append('valorChumbo234Ah', $("#valorTotalDeBateriasChumbo234Ah").text());
    formData.append('valorChumbo111Ah', $("#valorTotalDeBateriasChumbo111Ah").text());
    formData.append('valorLitio100Ah', $("#valorTotalDeBateriasLitio100Ah").text());

    $.ajax({
        url: $(this).attr('data-ajax'),
        type: 'POST',
        dataType: 'html',
        data: formData,
        contentType: false,
        processData: false,
        error: function () {
          
        },
        success: function (html) {
            $("#generatePDF")[0].click();
        }
    });
});

$("input[type='number']").on('keyup', function() {
    limitNumbers($(this));
});

$("input[type='number']").on('keydown', function() {
    limitNumbers($(this));
});

$(".tooltip-button").on('hover', function() {
    $('.tooltip-text').css({"z-index" : '3'});
});

function limitNumbers(obj) {
    let min = parseInt(obj.attr('min'));
    let max = parseInt(obj.attr('max'));
    let val = obj.val();
    if (val.match(/\D/g) && obj.attr("id") != 'dias-autonomia' && obj.attr("id") != 'hrs-dia') {
        val = val.replace(/\D/g, '');
        obj.val(val);
    }

    if (min && parseInt(val).toFixed(0) < min) {
        obj.val(min);
    }
    if (max && parseInt(val).toFixed(0) > max) {
        obj.val(max);
    }
}

function getData()
{
    let blocos = $(".bloco").get();
    let title = [];
    let quantidade = [];
    let potencia = [];
    let horas = [];
    let dias_mes = [];
    let dias_autonomia = [];
    
    blocos.forEach(function (key, value) {
        title.push($(key).children('[name="descricao"]').val());
        quantidade.push($(key).children('[name="quantidade"]').val());
        potencia.push($(key).children('[name="potencia"]').val());
        horas.push($(key).children('[name="hrs-dia"]').val());
        dias_mes.push($(key).children('[name="dias_uso_mes"]').val());
        dias_autonomia.push($(key).children('[name="dias_autonomia"]').val());
    });

    blocos['title'] = title;
    blocos['quantidade'] = quantidade;
    blocos['potencia'] = potencia;
    blocos['horas'] = horas;
    blocos['dias_mes'] = dias_mes;
    blocos['dias_autonomia'] = dias_autonomia;

    return blocos;
}